<template>
    <div>
        <div class="soft-box" v-if="dataList.length>0">
            <div v-for="(item,index) in dataList" class="soft-item" @click="viewCourse(item)" :key="index">
                <p class="dataType" :style="`background-color: ${filterDataType(item.dataType).value};`">{{ filterDataType(item.dataType).label }}</p>
                <div v-if="item.courseStatus" class="no-start-label" :style="`background-color:${filterStatus(item.courseStatus)};`">{{ item.courseStatus }}</div>
                <div v-if="item.type=='虚拟仿真'" class="no-start-label" :class="filterVersion(item.resType).value">{{ filterVersion(item.resType).label }}</div>
                <el-image
                style="width: 100%;aspect-ratio:var(--aspectRatio);"
                :src="item.coverImageUrl?$severUrl(item.coverImageUrl):$filterResDefault(type=='course'?item.classifyCode:item.type)"
                fit="cover"></el-image>
                <div class="bottom-box">
                    <el-tooltip v-if="item.courseName" :disabled="item.courseName.length<=15" class="item" effect="dark" :content="item.courseName" placement="top-start">
                        <p class="overflow">{{ item.courseName||'暂无' }}</p>
                    </el-tooltip>
                    <p v-else>{{ item.courseName||'暂无' }}</p>
                    <el-tooltip class="item" :disabled="item.courseDescription.length<=15" v-if="item.courseDescription" effect="dark" :content="item.courseDescription" placement="top-start">
                        <p class="overflow">{{ item.courseDescription||'暂无' }}</p>
                    </el-tooltip>
                    <p v-else>{{ item.courseDescription||'暂无' }}</p>
                    <div class="banner-box">
                        <div>
                            <el-tooltip class="item" effect="dark" content="学习人数" placement="top-start">
                                <img class="rs" src="../../assets/image/operation/rs.png" alt="">
                            </el-tooltip>
                            <div class="item-num">{{ item.studyCount||0 }}</div>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="学习次数" placement="top-start">
                                <img class="cs" src="../../assets/image/operation/cs.png" alt="">
                            </el-tooltip>
                            <div class="item-num">{{ item.studyNumberCount||0 }}</div>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="收藏次数" placement="top-start">
                                <img class="dz" src="../../assets/image/operation/dz.png" alt="">
                            </el-tooltip>
                            <div class="item-num">{{ item.collectCount||0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <no-data v-else></no-data>
    </div>
</template>

<script>
import { filterStatus,filterVersion } from '@/utils/utils';
    export default {
        props:{
            dataList:{
                require:true,
                default:()=>[]
            },
            type:{
                require:false,
                default:'course'
            }
        },
        data(){
            return {
                DZ:require('@/assets/image/operation/dz.png')
            }
        },
        methods:{
            filterStatus,
            /**点击查看课程详情 */
            viewCourse(item){
                this.$emit('view_course',item);
            },
            filterVersion,
            filterDataType(type){
                var path=this.$route.path;
                var obj={};
                if(path=='/course'){
                    obj={
                        1:{
                            label:'云课程',
                            value:'#387DFF'
                        },
                        0:{
                            label:'校企课程',
                            value:'#FE7C4B'
                        },
                    }
                }else{
                    obj={
                    0:{
                        label:'云资源',
                        value:'#387DFF'
                    },
                    1:{
                        label:'校企资源',
                        value:'#FE7C4B'
                    },
                    2:{
                        label:'本地资源',
                        value:'#D5698A'
                    }
                }
                }
            return obj[type]||{};
        },
        }
    }
</script>

<style lang="less" scoped>
.soft-box{
    display: flex;
    flex-wrap: wrap;
    row-gap: 4rem;
    column-gap:1.5rem;
    .soft-item{
        width: calc((100% - 4.5rem)/4);
        min-width: 31.5rem;
        background-color: #ffffff;
        box-shadow: 0px 0px 11.96px 0px rgba(225,229,239,0.50); 
        cursor: pointer;
        transition:all 0.3s;
        position: relative;
        &>img{
            width: 100%;
            height: 24rem;
        }
        .bottom-box{
            padding: 2rem;
            &> :nth-child(1){
            font-size: 2rem;
            font-weight: 700;
            color: #151C34;
            height: 2.6rem;
            }
            &> :nth-child(2){
                margin-top: 1.8rem;
                font-size: 16px;
                color: #9BA0B0;
                border-bottom: 1px solid #F3F5F9;
                padding-bottom: 2rem;
            }
        }
        .banner-box{
            width: 100%;
            margin-top: 2rem;
            padding-right: 3rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &> :nth-child(n){
                display: flex;
                align-items: center;
                i{
                    color: var(--blue);
                    font-size: 2rem;
                    font-weight: 700;
                }
                .item-num{
                    font-size: 16px;
                    color: #334681;
                    font-weight: 700;
                    margin-left: 1rem;
                }
            }
        }
    }
}   
.dataType{
            position: absolute;
            left: 0;
            top: 0;
            // width: 8rem;
            // height: 3.2rem;
            padding: 0.5rem 1rem;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            border-radius: 0.5rem;
            z-index: 80;
        }
.soft-item:hover{
    transform: translateY(-2rem);
}
.no-start-label{
    width: 8rem;
    padding: 0.5rem 0;
    color: #ffffff;
    border-radius: 0px 0px 0px 2.4rem;
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
@media screen and (max-width:750px){
   .soft-item{
    width: 100% !important;
   }
}
</style>